// eslint-disable-next-line
export const types = {
  installedat: {
    dataKey: 'installedAt',
    displayTextTranslationKey: 'type.installedat.DISPLAY_TEXT',
  },
  customer: {
    dataKey: 'customer',
    displayTextTranslationKey: 'type.customer.DISPLAY_TEXT',
    editInfoTextTranslationKey: 'type.customer.EDIT_INFO_TEXT',
  },
  functionallocation: {
    dataKey: 'functionalLocation',
    displayTextTranslationKey: 'type.functionallocation.DISPLAY_TEXT',
  },
  equipment: {
    dataKey: 'equipment',
    displayTextTranslationKey: 'type.equipment.DISPLAY_TEXT',
  },
  order: {
    dataKey: 'order',
    displayTextTranslationKey: 'type.order.DISPLAY_TEXT',
    serviceOrderNoteType: 'OSOD',
    invoiceTextNoteType: 'OIT',
  },
  notification: {
    dataKey: 'notification',
    displayTextTranslationKey: 'type.notification.DISPLAY_TEXT',
  },
  technician: {
    dataKey: 'technician',
    displayTextTranslationKey: 'type.technician.DISPLAY_TEXT',
  },
  call: {
    dataKey: 'call',
    displayTextTranslationKey: 'type.call.DISPLAY_TEXT',
  },
  ticket: {
    dataKey: 'ticket',
    displayTextTranslationKey: 'type.ticket.DISPLAY_TEXT',
  },
};
